import { PButtonPure, PText } from '@porsche-design-system/components-react'
import React from 'react'

import styles from './button.module.css'

type Props = {
  icon: string
  size: 'small' | 'x-small' | 'medium' | 'large' | 'x-large' | 'inherit' | undefined
  onClick: (event: React.MouseEvent) => void
  buttonText: string
  testState?: boolean
  loading?: boolean
}

const Button = ({ icon, size, onClick, buttonText, testState = false, loading }: Props) => {
  const [mouseOver, setMouseOver] = React.useState(false)

  return (
    <PButtonPure
      iconSource={icon}
      size={size}
      className={styles.link}
      onClick={onClick}
      onMouseEnter={() => setMouseOver(true)}
      onMouseLeave={() => setMouseOver(false)}
      loading={loading}
    >
      <PText color={mouseOver ? 'brand' : 'default'} className={styles.text}>
        {buttonText} {testState && ' [Test]'}
      </PText>
    </PButtonPure>
  )
}

export default Button
